import { render, staticRenderFns } from "./DebtLoadBreak.vue?vue&type=template&id=8487470c&scoped=true&"
var script = {}
import style0 from "./DebtLoadBreak.vue?vue&type=style&index=0&id=8487470c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8487470c",
  null
  
)

export default component.exports